export const LINK_ENTITY_TYPE = "LINK";
export const LINK_ENTITY_MUTABILITY = "MUTABLE";
